<template>
    <div class="container">
        <div class="page-top mb-1 mb-3 clearfix">
                <h1 class="float-left">Add Vendor Category</h1>
        </div>
        <div class="global-main">
            <form id="vendorCategoryForm" @submit.prevent="addVendorCategoryData">
                <div class="tab-content-inner">
                    <div class="form-group">
                        <label> Name </label>
                        <input v-model="form.name" type="text" name="name" class="form-control" :class="{ 'is-invalid': form.errors.has('name') }">
                        <has-error :form="form" field="name"></has-error>
                    </div>
                </div>
                <div class="form-group">
                    <button :disabled="form.busy" class="btn btn-primary float-right active">Save</button>
                    <router-link to="/vendorCategories" class="btn btn-primary float-right mr-2">Cancel</router-link>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form: new Form({
                    name : '',
                }),
            }
        },
        methods: {
            addVendorCategoryData() {
                this.$Progress.start();
                this.form.post('api/addVendorCategory')
                .then(res => {
                    if(res.status == 200){
                        this.$Progress.finish();
                        toast.fire({
                            type: 'success',
                            title: 'Vendor Category created successfully'
                        });
                        this.$router.push('/vendorCategories');
                    }else{
                        this.$Progress.fail();
                    }

                })
                .catch(err => {
                    this.$Progress.fail();
                    swal.fire({
                        type: 'error',
                        title: 'Some problem in your form data'
                    });
                });
            }
        },
        created() {
            //
        },
    }
</script>
